import { useEffect, useCallback } from "react";
import { useParameter, useFavouriteProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";

export function useFavourite() {
  const title = useSlideTitle();
  const {
    actions: { setParameters, setApplyFunction },
  } = useFavouriteProviderContext();

  const [business, setBusiness] = useParameter<number>("@business-units");

  useEffect(() => {
    setParameters(title, {
      "@business-units": business,
    });
  }, [title, business, setParameters]);

  const applyParameters = useCallback(
    (parameters: Record<string, string[]>) => {
      setBusiness(parameters["@business-units"].map(Number)[0]);
    },
    [setBusiness]
  );

  useEffect(() => {
    setApplyFunction(applyParameters);
  }, [setApplyFunction, applyParameters]);
}
